// src/pages/PDFViewerPage.js
import React from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import PDFViewer from '../components/players/PDFViewer';

const PDFViewerPage = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  // اولویت با state است (اگر از navigate استفاده شده باشد)
  const stateData = location.state || {};

  // در غیر این صورت، از query parameters می‌خوانیم
  const fileUrl = stateData.fileUrl || searchParams.get('url') || '';
  const mediaId = stateData.mediaId || searchParams.get('mediaId') || null;
  const title = stateData.title || searchParams.get('title') || '';

  return (
    <PDFViewer
      mediaId={mediaId}
      fileUrl={fileUrl}
      title={title}
    />
  );
};

export default PDFViewerPage;